
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import VerticalTabs from 'components/VerticalTabs'
import categories from '@divvit/common-categories'
import {
  fetchMappingsForCategory,
  removeMappingsForCategory
} from 'redux/modules/settings/actions'
import {getMappings} from 'redux/modules/settings/selectors'
import propsChanged from 'utils/propsChanged'
import AddMappingForm from './AddMappingForm'
import EditMappingForm from './EditMappingForm'

const mapPathToItem = function(item) {
  if (item.items) {
    item.items = item.items.map(mapPathToItem)
  }
  return {...item, to: `/settings/categories/${item.key}`}
}

export class SettingsCategoriesView extends React.Component {
  static propTypes = {
    categoryId: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.object).isRequired,
    mappings: PropTypes.array,
    fetchMappingsForCategory: PropTypes.func.isRequired,
    removeMappingsForCategory: PropTypes.func.isRequired
  }

  componentWillMount() {
    const {categoryId, fetchMappingsForCategory} = this.props
    fetchMappingsForCategory(categoryId)
  }

  componentWillReceiveProps(nextProps) {
    if (propsChanged(this.props, nextProps, ['categoryId'])) {
      const {categoryId, fetchMappingsForCategory} = nextProps
      fetchMappingsForCategory(categoryId)
    }
  }

  render() {
    const {categories, categoryId, mappings, removeMappingsForCategory} = this.props

    return (
      <div className='settings-categories-view container'>
        <div className='settings-categories-view_categories'>
          <VerticalTabs items={categories.map(mapPathToItem)} activeItemId={categoryId} />
        </div>
        <div className='settings-categories-view_mappings'>
          <AddMappingForm category={categoryId} />
          <EditMappingForm
            mappings={mappings}
            category={categoryId}
            onRemoveMappings={mappingIds => removeMappingsForCategory({category: categoryId, mappingIds})}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, {params: {categoryId}}) => ({
  categoryId,
  categories: categories(),
  mappings: getMappings(state, categoryId)
})

export default connect(mapStateToProps, {
  fetchMappingsForCategory,
  removeMappingsForCategory
})(SettingsCategoriesView)



// WEBPACK FOOTER //
// ./client/views/SettingsCategoriesView/index.js